<script>
import Vue from 'vue'
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import nfsaidaForm from './nfsaida-form'
import duimpForm from './duimp-form'
import { apiDownloadPDF, apiORDSpost, apiValidaLimitePlano } from '../shared/api-functions'
import { urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao de DI
            showEntradaForm: false, //exibe a tela de manutencao de nota de entrada
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            filterList: [], //lista de filtros aplicados que são exibidos em tela
            moreActionsBarList: [],
            monthFilter: {},
            showModalImport: false,
            duimpNumber: '',
            errorMsg: '',
        }
    },
    computed: {
        diList: function () {
            return this.$store.getters.getDuimpList
        },
    },
    methods: {
        moreActionsGrid (di) {
            var obj = []
            if (di.stdi == '1') {
                obj.push({ action: '1', label: 'Gerar NFe', id: di.coddi})
            }
            if (di.codnf) {
                obj.push({ action: '2', label: 'Visualizar Danfe', id: di.codnf})
            }
            return obj
        },

        optionsGrid (di) {
            if (di.stdi == '0') {
              return {barDefault: true, btnEdit: true, btnDelete: true, btnView: true}
            } else
            if (di.stdi == '1') {
              return {barDefault: true, btnEdit: true, btnDelete: true, btnView: true}
            } else {
              return {barDefault: true, btnEdit: false, btnDelete: false, btnView: true}
            }
        },

        handleEdit (coddi) {
            this.crud = SysVars.crudU
            this.params = { coddi: coddi }
            this.showForm = true
        },

        handleDelete (coddi) {
            this.crud = SysVars.crudD
            this.params = { coddi: coddi }
            this.showForm = true
        },

        handleEditNFe (codnf) {
            this.crud = SysVars.crudU
            this.params = { codnf: codnf }
            this.showEntradaForm = true
        },

        handleView (coddi) {
            this.crud = SysVars.crudView
            this.params = {}
            this.params.coddi = coddi
            this.showForm = true;
        },

        async apiPostNFe (coddi) {
            var sendData = { di: { coddi: coddi, diit: [] } }
            const data = await apiORDSpost(this.$store, 'invoice/nfimportacao/di/', sendData, 'post')
            if (data.items) {
                if (data.errmessages) {
                    this.$erpToastError('Erro: ' + data.errmessages[0])
                } else {
                    let codnf = data.items[0].codnf
                    this.handleEditNFe(codnf)
                    this.$erpToastSuccess('A NF-e foi gerada com sucesso.')
                }
            }
        },

        handleAction (act, obj) {
            if (act == 1) {
              this.apiPostNFe(obj.coddi)
            }
            if (act == 2) {
                if (obj && obj.codnf)
                  apiDownloadPDF(this, 'print/previewdanfe/' + obj.codnf)
            }
        },

        handleActionBarList (act) {
            if (act == 1) {
                this.handleImportarDuimp()
            }
        },

        handleIncluir () {
            this.handleImportarDuimp()
        },

        closeForm() {
            this.showEntradaForm = false
            this.showForm = false
            this.loadData()
        },

        handleSearch(value) {
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"numerodi":{"$eq":"' + value + '"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadDuimpList', { filter: this.filter} )
        },

        textST (value) {
            return getText(value, this.metadata.di.stdi)
        },

        data (value) {
            return formatDate(value)
        },

        async handleImportarDuimp() {
            const isValid = await apiValidaLimitePlano(this, 'nfimportacao_duimp')
            if (!isValid) return

            this.duimpNumber = ''
            this.errorMsg = ''
            this.showModalImport = true
        },

        executeImport() {
            if (!this.duimpNumber) {
                this.$erpToastError('Informe o número da DUIMP')
                return
            }

            var self = this
            var sendData = { numero: this.duimpNumber }
            this.errorMsg = ''

            let modulo = 'invoice/duimp/'
            Vue.prototype.$appLoading(true)
            axios.post(urlORDS(this.$store, modulo), sendData
            ).then(function(response){
                Vue.prototype.$appLoading(false)
                if (response.data.errmessages) {
                    let msg = response.data.errmessages[0]

                    // Tenta limpar a mensagem se for um JSON aninhado
                    const cleanMsg = (text) => {
                        if (!text || typeof text !== 'string') return text
                        if (text.includes('): {')) {
                            text = text.substring(text.indexOf('): ') + 3)
                        }
                        try {
                            const obj = JSON.parse(text)
                            if (obj.error) return cleanMsg(obj.error)
                            if (obj.message) return cleanMsg(obj.message)
                            if (obj.detail) return cleanMsg(obj.detail)
                        } catch (e) {}
                        return text
                    }

                    self.errorMsg = cleanMsg(msg)
                    self.$erpToastError('Erro na importação da DUIMP: ' + self.errorMsg)
                } else {
                    self.showModalImport = false
                    let coddi = response.data.items[0].coddi
                    self.handleEdit(coddi)
                    self.$erpToastSuccess('A DUIMP foi importada com sucesso.')
                }
            }).catch(function(error) {
                Vue.prototype.$appLoading(false)
                let msg = 'Erro ao processar requisição no servidor.'
                if (error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message
                } else if (error.message) {
                    msg = error.message
                }
                self.errorMsg = msg
                self.$erpToastError('Erro na importação: ' + msg)
            })

        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    components: {
        BarList, BarGrid, duimpForm, nfsaidaForm
    },

    created () {
        this.moreActionsBarList = [
            { action: 1, label: 'Importar DUIMP Siscomex' }]

        this.showForm = false
        this.loadData()
    }
}
</script>

<template>
    <div>
        <div id="list" v-show="!showForm && !showEntradaForm">
            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                :filtro-mes="true"
                :filter-button="true"
                single-entity="DUIMP"
                plural-entity="DUIMPs"
                :moreActions="moreActionsBarList"
                :month-filter="monthFilter"
                @action="handleActionBarList"
                @search="handleSearch"
                @new="handleIncluir"
                @refresh="loadData"
                @changeMonth="handleSearch"
                title-search="Pesquise pelo nome do fornecedor ou número do DUIMP">
            </bar-list>

            <div class="default-container mt-3">
                <alert v-if="diList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="di in diList" v-bind:key="di.coddi">
                    <div class="mark-gray"></div>
                    <div class="box pl-3 pl-md-0">
                        <div class="row">
                            <div class="col-7 col-md-12 row">
                                <div class="col-md-2 col-12" style="float: left">
                                    <label class="lbl-list">Número </label><br>
                                    <span class="data-list">{{ di.numerodi }}</span>
                                </div>
                                <div class="col-md-2 col-12 d-none d-md-block">
                                    <label class="lbl-list">Data:</label><br>
                                    <span class="data-list">{{ data(di.data) }}</span>
                                </div>
                                <div class="col-md-3 col-12 d-md-flex d-none">
                                    <label class="lbl-list">Natureza:</label><br>
                                    <span class="data-list">{{ di.descricao }}</span>
                                </div>
                                <div class="col-md-2 col-3">
                                    <label class="lbl-list">Total FOB:</label><br>
                                    <span class="data-list">{{ di.vfob | format }}</span>
                                </div>
                                <div class="col-md-2 col-5 d-none d-md-block">
                                    <bar-grid
                                        :obj="di"
                                        :options="optionsGrid(di)"
                                        :moreActions="moreActionsGrid(di)"
                                        @view="handleView(di.coddi)"
                                        @edit="handleEdit(di.coddi)"
                                        @delete="handleDelete(di.coddi)"
                                        @action="handleAction">
                                    </bar-grid>
                                </div>
                            </div>
                            <div class="col-5 d-flex flex-column align-items-end justify-content-end d-md-none">
                                <div class="col-md-2 col-6">
                                    <bar-grid
                                        :obj="di"
                                        :options="optionsGrid(di)"
                                        :moreActions="moreActionsGrid(di)"
                                        @view="handleView(di.coddi)"
                                        @edit="handleEdit(di.coddi)"
                                        @delete="handleDelete(di.coddi)"
                                        @action="handleAction">
                                    </bar-grid>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 col-3">
                                <span class="badge" :class="[{'badge-green': di.stdi=='1'},{'badge-orange': di.stdi=='0'}]" >{{ textST(di.stdi) }}</span>
                            </div>
                            <div class="col-md-5 col-6 d-md-flex d-none">
                                <label class="lbl-list">Fornecedor:</label><br>
                                <span class="data-list">{{ di.nome }}</span>
                            </div>
                            <div v-if="di.nf" class="col-md-2 col-3 d-md-flex d-none">
                                <label class="lbl-list">Série/NF:</label><br>
                                <span class="data-list">{{ di.nf }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para informar o número da DUIMP -->
        <div class="nb-modal-scrollable" v-if="showModalImport">
            <div class="container nb-modal-scrollable-container">
                <div class="nb-modal-header">
                    <h5>Importar DUIMP do Siscomex</h5>
                    <button type="button" class="close" @click="showModalImport = false">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body p-4">
                    <div class="row" v-if="errorMsg">
                        <div class="col-12">
                            <div class="alert alert-danger py-2 mb-3">
                                <i class="fa fa-exclamation-triangle mr-2"></i> {{ errorMsg }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <v-label label="Número da DUIMP (Ex: 24BR000000001)"></v-label>
                            <form-field v-model="duimpNumber" type="text" case="normal"></form-field>
                        </div>
                    </div>
                </div>
                <div class="nb-modal-scrollable-footer">
                    <v-button label="Importar" :nb-btdef="true" @click="executeImport"></v-button>
                    <v-button label="Cancelar" @click="showModalImport = false"></v-button>
                </div>
            </div>
        </div>

        <!-- FORMULARIO DE EDICAO DA DI -->
        <duimp-form v-if="showForm" :params="params" :crud="crud" v-on:closeform="closeForm"></duimp-form>

        <!-- FORMULARIO DE EDICAO DA NF -->
        <nfsaida-form v-if="showEntradaForm" :params="params" :crud="crud" v-on:closeform="closeForm"></nfsaida-form>
    </div>
</template>

<style scoped>
.mainbox {
  min-height:100px;
}

</style>



// WEBPACK FOOTER //
// src/forms/duimp-list.vue